module.exports = __webpack_public_path__ + "static/a-virus-hits-home-9691d7ad6c601175a036a66d63186b98.jpg";